import { nullable } from '@ipfabric/utils/fp/nullable';
import { prop } from '@ipfabric/utils/fp/prop';
import {
  type GraphState,
  type PathLookupGraphMetadata,
  isPathLookupGraphMetadata,
} from 'components/Graph/GraphState';
import { flow } from 'fp-ts/lib/function';

export const selectPathLookupMetadata: (
  s: GraphState,
) => PathLookupGraphMetadata | null = flow(
  prop('graphMetadata'),
  nullable.fromPredicate(isPathLookupGraphMetadata),
);
